export enum LifeInsuranceCustomFieldKey {
	NameOfInsuranceCompany = 'lifeInsuranceNameOfInsuranceCompany',
	InsuranceType = 'lifeInsuranceInsuranceType',
}